import React from 'react';

import FaqPage from '../components/FaqPage';

const FAQ = () => (
  <FaqPage
    lang="es"
    title="FAQ | Full Stack open"
    seoDescription="Preguntas frecuentes"
  />
);

export default FAQ;
